"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickerStepButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../Button");
const Root = styled_1.default.div `
  display: flex;
  align-items: center;
`;
const StyledButton = (0, styled_1.default)(Button_1.Button) `
  border-radius: 50%;
  padding: 8px;
`;
const Middle = styled_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
`;
const PickerStepButtons = ({ onMinusClick, onPlusClick, minusDisabled, plusDisabled, children, }) => {
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(StyledButton, { icon: "MinusIcon", design: "white", size: "sm", onClick: onMinusClick, disabled: minusDisabled }), (0, jsx_runtime_1.jsx)(Middle, { children: children }), (0, jsx_runtime_1.jsx)(StyledButton, { icon: "PlusIcon", design: "white", size: "sm", onClick: onPlusClick, disabled: plusDisabled })] }));
};
exports.PickerStepButtons = PickerStepButtons;
